import React from "react";
import _ from "lodash";
import { Link, useParams } from "react-router-dom";
import useDivisions from "../../hooks/queryResults/useDivisions";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import useStandings from "../../hooks/queryResults/useStandings";
import useTeams from "../../hooks/queryResults/useTeams";
import useWeek from "../../hooks/queryResults/useWeek";
import Box from "../layout/Box";
import TeamLogo from "../team/TeamLogo";
import Loading from "../ui/Loading";

const LeagueStandings = () => {
  const { league: leagueUrl, season: seasonUrl, week: weekUrl } = useParams();
  const { divisionsData, divisionsQuery } = useDivisions();
  const { leagueSeason, leagueQuery } = useLeagueSeason();
  const { selectedWeek } = useWeek();
  const { standingsData, standingsQuery } = useStandings(selectedWeek);
  const { teams, teamsQuery } = useTeams();

  const isLoading = useIsLoading(
    divisionsData,
    divisionsQuery,
    standingsData,
    standingsQuery,
    leagueSeason,
    leagueQuery,
    teams,
    teamsQuery
  );
  if (isLoading) return <Loading />;

  console.log("leagueSeason", leagueSeason);
  console.log("standingsData", standingsData);
  console.log("divisionsData", divisionsData);

  const numCols = selectedWeek > 5 ? 13 : 12;

  let someoneClinched = false;
  const clinchedDivIcon = "$";
  const clinchedPlayoffsIcon = "*";

  return (
    <div>
      <Box title={"standings"} centerContent={true}>
        <table style={{ border: "4px solid white" }}>
          <tbody>
            {Object.keys(divisionsData.divisionSeasons)
              .map((id) => divisionsData.divisionSeasons[id])
              .sort((a, b) => {
                return a.name <= b.name ? -1 : 1;
              })
              .map((ds, i) => {
                return (
                  <React.Fragment key={i}>
                    <tr
                      style={{
                        backgroundColor: ds.colors.first,
                        color: ds.colors.second,
                      }}
                    >
                      <th colSpan={numCols}>{ds.name} Division</th>
                    </tr>
                    <tr
                      style={{
                        backgroundColor: ds.colors.first,
                        color: ds.colors.second,
                      }}
                    >
                      <th title={"Rank"}>Rk</th>
                      <th colSpan={2}>Team</th>
                      <th>W</th>
                      <th>L</th>
                      <th>Pct</th>
                      <th>PFA</th>
                      <th>PAA</th>
                      <th>Div</th>
                      <th>Home</th>
                      <th>Away</th>
                      {selectedWeek > 5 ? <th>Last 5</th> : null}
                      <th>Streak</th>
                    </tr>
                    {standingsData.standings
                      .filter((st) => st.divisionSeason === ds.id)
                      .sort((a, b) => {
                        if (a.rank === b.rank) {
                          if (a.recordTotal?.pct === b.recordTotal?.pct) {
                            if (a.recordVsTied?.pct === b.recordVsTied?.pct) {
                              if (a.recordVsDiv?.pct === b.recordVsDiv?.pct) {
                                return a.recordTotal?.pointsForAvg >=
                                  b.recordTotal?.pointsForAvg
                                  ? -1
                                  : 1;
                              }
                              return a.recordVsDiv?.pct >= b.recordVsDiv?.pct
                                ? -1
                                : 1;
                            }
                            return a.recordVsTied?.pct >= b.recordVsTied?.pct
                              ? -1
                              : 1;
                          }
                          return a.recordTotal?.pct >= b.recordTotal?.pct
                            ? -1
                            : 1;
                        }
                        return a?.rank <= b?.rank ? -1 : 1;
                      })
                      .map((st, i) => {
                        const team = teams.getTeamById(st.team);

                        const pfa = st.recordTotal.pointsForAvg.toFixed(2);
                        const paa = st.recordTotal.pointsAgainstAvg.toFixed(2);

                        const getRecordString = (record) => {
                          const elements = [record.wins, record.losses];
                          if (record.ties) elements.push(record.ties);
                          return elements.join("-");
                        };

                        const streakStr = _.capitalize(
                          st.recordTotal.streakType
                        );
                        let color = "#000";
                        if (streakStr.charAt(0) === "W") color = "#00ab00";
                        if (streakStr.charAt(0) === "L") color = "#f00";
                        const streak = (
                          <span style={{ color }}>
                            {streakStr} {st.recordTotal.streakNum}
                          </span>
                        );

                        const teamLinkPath = `/${leagueUrl}/${seasonUrl}/${team.idOrSlug}/${weekUrl}`;

                        const clinchedSeed = st.clinchedSeed || null;
                        let clinchedIcon = null;
                        if (clinchedSeed && clinchedSeed <= 3) {
                          someoneClinched = true;
                          clinchedIcon =
                            clinchedSeed === 1
                              ? clinchedDivIcon
                              : clinchedPlayoffsIcon;
                        }

                        return (
                          <tr key={i}>
                            <td>
                              {clinchedIcon}
                              {st.rank}
                            </td>
                            <td>
                              <TeamLogo
                                team={team}
                                linkPath={teamLinkPath}
                                week={selectedWeek}
                                size={"sm"}
                              />
                            </td>
                            <td className={"left"}>
                              <Link to={teamLinkPath}>{team.fullName}</Link>
                            </td>
                            <td>{st.recordTotal.wins}</td>
                            <td>{st.recordTotal.losses}</td>
                            <td>{st.recordTotal.pct.toFixed(3)}</td>
                            <td>{pfa}</td>
                            <td>{paa}</td>
                            <td>{getRecordString(st.recordVsDiv)}</td>
                            <td>{getRecordString(st.recordHome)}</td>
                            <td>{getRecordString(st.recordAway)}</td>
                            {selectedWeek > 5 ? (
                              st.recordLastFive ? (
                                <td>{getRecordString(st.recordLastFive)}</td>
                              ) : (
                                <td>{getRecordString(st.recordTotal)}</td>
                              )
                            ) : null}
                            <td>{streak}</td>
                          </tr>
                        );
                      })}
                  </React.Fragment>
                );
              })}
            {someoneClinched ? (
              <>
                <tr>
                  <td>{clinchedDivIcon} - Clinched Division Title</td>
                </tr>
                <tr>
                  <td>{clinchedPlayoffsIcon} - Clinched Playoff Berth</td>
                </tr>
              </>
            ) : null}
          </tbody>
        </table>
      </Box>
    </div>
  );
};

export default LeagueStandings;
